export default {
    addCount(state,payload){
        payload.count++;
        // console.log("--++")
    },
    addToCart(state,payload){
        // console.log("---");
        payload.checked=true;
        state.cartList.push(payload)
    }
}